import Header from '../components/Header';
import './Home.css';
import { SUPPORT_EMAIL } from '../constants/contact';

function HeadacheNoteTerms() {
  return (
    <div className="Home" id="headache-note-terms">
      <Header />
      <main>
        <section className="Legal">
          <h1>頭痛ノート 利用規約</h1>
          <p>
            この利用規約（以下、「本規約」といいます。）は、本サービス運営者（以下、「運営者」といいます。）が提供する「頭痛記録アプリ」（以下、「本サービス」といいます。）の利用条件を定めるものです。本サービスを利用する前に、必ず本規約をお読みください。本サービスを利用することにより、利用者は本規約に同意したものとみなされます。
          </p>

          <h2>第1条（適用）</h2>
          <p>
            本規約は、本サービスの利用に関わる一切の関係に適用されます。運営者は本サービスに関し、関連法令、本規約および各種ガイドラインに従って運営します。
          </p>

          <h2>第2条（インターネット接続について）</h2>
          <p>
            本サービスはインターネット接続が必要な機能を含んでいます。スマートフォンがインターネットに接続されていない場合、本サービスの一部または全部が正常に動作しないことがありますので、あらかじめご了承ください。
          </p>
          <p>
            インターネット接続に伴う通信料は、利用者が契約する通信事業者の定めに従い、利用者の負担となります。
          </p>

          <h2>第3条（利用登録）</h2>
          <p>
            本サービスの利用を希望する者は、本規約に同意の上、運営者の定める方法により利用登録を行うものとします。運営者は、利用登録の申請者に以下の事由があると判断した場合、利用登録の申請を承認しないことがあります。
          </p>
          <ul>
            <li>利用登録の申請に際して虚偽の事項を届け出た場合</li>
            <li>過去に本規約に違反したことがある場合</li>
            <li>その他、運営者が利用登録を相当でないと判断した場合</li>
          </ul>

          <h2>第4条（ユーザーIDおよびパスワードの管理）</h2>
          <p>
            利用者は、自己の責任において本サービスのユーザーIDおよびパスワードを適切に管理するものとします。ユーザーIDおよびパスワードの管理不十分、使用上の過誤、第三者の使用等による損害は、利用者が負担するものとします。運営者は、ユーザーID及びパスワードの不正使用によって生じた損害について、一切の責任を負いません。
          </p>

          <h2>第5条（サブスクリプションサービスおよび利用料金）</h2>
          <p>
            本サービスの基本機能の一部は無料で提供されますが、追加機能その他のプレミアム機能については、月額のサブスクリプションサービス（以下、「本サブスクリプション」といいます。）として有料で提供される場合があります。
          </p>
          <p>
            本サブスクリプションの内容、利用料金、提供開始日その他の条件は、運営者が別途定め、本サービス内またはアプリストア（Apple App Store、Google Playストア等。以下「ストア」といいます。）上に表示するものとします。
          </p>
          <p>
            利用者は、本サブスクリプションの利用に際し、ストアが定める決済手段（クレジットカード決済、ストアのアカウント決済等）により、運営者が別途定める利用料金を支払うものとします。
          </p>
          <p>
            本サブスクリプションは、利用者がストア所定の手続により解約しない限り、自動的に更新される自動継続課金方式となります。
          </p>
          <p>
            利用者は、本サブスクリプションの解約を希望する場合、各ストアが定める手続に従い、自ら解約手続を行うものとします。運営者が利用者に代わって解約手続を行うことはできません。
          </p>
          <p>
            既に支払われた利用料金については、ストアの定めるところに従う場合を除き、日割り計算による返金・払い戻しは行われません。
          </p>
          <p>
            運営者は、必要に応じて本サブスクリプションの内容および利用料金を変更することができるものとします。この場合、運営者は本サービス内またはストア上で事前に告知します。
          </p>

          <h2>第6条（無料トライアル）</h2>
          <p>
            運営者は、本サブスクリプションについて、無料トライアル期間（以下、「無料トライアル」といいます。）を提供することがあります。無料トライアルの有無や期間、対象者その他の条件は、運営者が別途定め、本サービス内またはストア上に表示するものとします。
          </p>
          <p>
            無料トライアル期間中に解約手続を行った場合でも、既に支払われた料金があるときは、ストアの定めに従う場合を除き、返金は行われません。
          </p>
          <p>無料トライアルの提供条件は、運営者の判断により予告なく変更または終了されることがあります。</p>

          <h2>第7条（位置情報等の取得および利用）</h2>
          <p>
            本サービスは、天気情報の表示、頭痛記録の振り返り・分析補助、レコメンド、通知その他本サービスの機能提供のため、次の情報（総称して、以下「位置情報等」といいます。）を取得し、利用する場合があります。
          </p>
          <ul>
            <li>
              利用者の端末から取得される位置情報（緯度・経度、概ねの現在地情報等。以下「端末位置情報」といいます。）
            </li>
            <li>
              利用者が本サービス上で手動設定する地域に関する情報、ならびに当該地域に対応する緯度・経度（以下「地域座標情報」といいます。）
            </li>
          </ul>
          <p>
            地域座標情報として取り扱う緯度・経度は、小数点以下4桁まで保持するものとし、本サービスの仕様上、四捨五入その他の方法により当該桁数に丸めて保存される場合があります。
          </p>
          <p>
            端末位置情報の取得は、利用者が端末の権限設定（位置情報へのアクセス許可）により許可した範囲で行われます。利用者は、端末設定または本サービス内の設定により、いつでも許可を変更または取り消すことができます。
          </p>
          <p>
            運営者は、位置情報等を、前項の目的の範囲内で利用し、運営者のサーバー上に保存する場合があります。利用者は、本サービス内の機能または運営者所定の方法により、位置情報等を任意のタイミングで削除することができます。削除の反映には合理的な範囲で時間を要する場合があります。
          </p>
          <p>
            利用者が位置情報等の提供を行わない場合、または提供を停止した場合、本サービスの一部機能（天気情報の表示、分析・レコメンド、通知等）が利用できない、または機能が制限されることがあります。
          </p>
          <p>
            本サービスは、天気情報の提供のため、第三者の気象情報サービス（OpenWeatherMap の API 等。以下「気象情報提供者」といいます。）を利用します。この場合、天気情報の取得に必要な範囲で、位置情報等（または当該位置情報等に対応する情報）その他のリクエスト情報が気象情報提供者に送信されることがあります。
          </p>
          <p>
            位置情報等および気象情報には誤差が生じる場合があります。運営者は、気象情報提供者が提供する情報（天気、気温、気圧、湿度等を含みますがこれに限られません。）の正確性、完全性、最新性、有用性等について保証しません。これらの情報の利用により利用者に生じた損害について、運営者は責任を負いません（ただし、運営者に故意または重大な過失がある場合を除きます）。
          </p>
          <p>
            位置情報等の取扱いの詳細（保存される情報の範囲、削除方法、第三者への送信・国外での処理が行われる可能性等）は、プライバシーポリシーに定めます。
          </p>

          <h2>第8条（AIレポート機能およびLLMの利用）</h2>
          <p>
            本サービスには、利用者が入力した頭痛の記録等の情報をもとに、AI（大規模言語モデル、LLM）を利用してレポートやアドバイス風のテキストを生成する機能（以下、「AIレポート機能」といいます。）が含まれる場合があります。
          </p>
          <p>
            運営者は、AIレポート機能の提供にあたり、OpenAI, L.L.C.その他の第三者が提供するLLMサービス（以下、「LLM提供者」といいます。）を利用します。
          </p>
          <p>利用者は、AIレポート機能の利用に際し、次の点に同意するものとします。</p>
          <ul>
            <li>
              利用者が本サービスに入力した内容（頭痛の症状、発生状況、服薬状況、メモ欄の記載内容等）が、AIレポートを生成する目的のために、LLM提供者のサーバーに送信されること
            </li>
            <li>
              運営者は、LLM提供者に対し、当該情報を学習用途には利用せず、AIレポート機能の提供のための処理に限定して利用するよう求めること
            </li>
            <li>運営者は、個人を特定できる情報の送信を最小限とするよう努めること</li>
            <li>
              運営者は、本サービスおよびAIレポート機能の品質向上・分析等のため、利用者の記録情報を個人が特定できない形式に加工したうえで、統計情報として利用することがあります。
            </li>
            <li>
              利用者が自ら以外の第三者に関する情報（家族・知人等）を本サービスに入力する場合、当該第三者から必要な同意を取得したうえで入力するものとし、利用者は自己の責任においてこれを行うものとします。
            </li>
            <li>
              AIレポート機能は、医学的な診断、治療、予防、その他の医療行為を目的としたものではなく、あくまで参考情報として提供されるものであり、医師その他の医療専門職による診断や助言に代わるものではありません。利用者は、健康状態や治療に関する判断を行う際には、必ず医師その他の医療専門職に相談するものとします。
            </li>
          </ul>

          <h2>第9条（禁止事項）</h2>
          <p>利用者は、本サービスの利用にあたり、以下の行為をしてはなりません。</p>
          <ul>
            <li>法令または公序良俗に違反する行為</li>
            <li>犯罪行為に関連する行為</li>
            <li>運営者、他の利用者、または第三者の知的財産権、肖像権、プライバシー等を侵害する行為</li>
            <li>本サービスの運営を妨害する行為、不正アクセスやその他の不正行為</li>
            <li>本サービスを医療行為の代替として用い、医師等の専門家による診断や治療を受けずに重大な判断を行う行為</li>
            <li>その他、運営者が不適切と判断する行為</li>
          </ul>

          <h2>第10条（本サービスの変更および終了）</h2>
          <p>
            運営者は、利用者への事前の通知なくして、本サービスの内容を変更または廃止することができます。運営者は、本サービスの変更または廃止により利用者または第三者に生じた損害について、一切の責任を負いません。
          </p>
          <p>
            有料の本サブスクリプションに係る提供内容を変更または終了する場合、運営者は本サービス内またはストア上で事前に告知するよう努めます。
          </p>

          <h2>第11条（著作権）</h2>
          <p>
            本サービスおよび本サービスに関連する一切のコンテンツ（文章、画像、プログラム等）の著作権その他の知的財産権は、運営者または正当な権利を有する第三者に帰属します。利用者は、運営者の事前の承諾なく、本サービスを通じて提供されるコンテンツを複製、転用、改変、公衆送信等してはなりません。
          </p>

          <h2>第12条（利用制限および登録抹消）</h2>
          <p>
            運営者は、以下の場合には、事前の通知なく利用者に対して本サービスの全部または一部の利用を制限または停止することができ、または利用契約を解除し、登録を抹消することができます。
          </p>
          <ul>
            <li>本規約に違反した場合</li>
            <li>不正な目的で本サービスを利用した場合</li>
            <li>その他、運営者が本サービスの利用を適当でないと判断した場合</li>
          </ul>
          <p>
            運営者は、本条に基づく措置により利用者に生じた損害について、一切の責任を負いません。
          </p>

          <h2>第13条（免責事項）</h2>
          <p>
            運営者は、本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、セキュリティなどに関する欠陥を含みます。）がないことを保証しておりません。運営者は、本サービス（AIレポート機能を含みます。）の利用により利用者に生じたあらゆる損害について、一切の責任を負いません。ただし、運営者に故意または重大な過失がある場合はこの限りではありません。
          </p>
          <p>
            本サービスが提供するAIレポートその他の情報は、医学的・専門的助言ではなく、参考情報にとどまるものであり、その正確性・有用性・適合性を保証するものではありません。
          </p>
          <p>
            利用者は、本サービスの利用に関し、必要に応じて医師その他の専門家の助言を受けるものとし、本サービスの情報のみに基づいて健康、医療、仕事、学業、生活その他の重要な意思決定を行わないものとします。
          </p>
          <p>運営者は、本サービスに第三者が提供するコンテンツに関して一切責任を負いません。</p>

          <h2>第14条（サービス利用規約の変更）</h2>
          <p>
            運営者は、必要と判断した場合には、利用者に通知することなくいつでも本規約を変更することができます。変更後の本規約は、本サービス上に掲載された時点、または運営者が別途定める時点から効力を生じるものとします。
          </p>
          <p>
            利用者が、本規約の変更後も本サービスを利用した場合、当該変更後の本規約に同意したものとみなします。
          </p>

          <h2>第15条（個人情報の取扱い）</h2>
          <p>
            運営者は、利用者の個人情報（健康情報、端末情報、位置情報等を含みます。）を「プライバシーポリシー」に従って適切に取り扱います。プライバシーポリシーは本規約の一部を構成するものとします。
          </p>
          <p>
            本サービスにおけるAIレポート機能に関連する個人情報および入力データの取扱いについても、プライバシーポリシーにおいて別途定めるものとします。
          </p>

          <h2>第16条（通知または連絡）</h2>
          <p>利用者と運営者との間の通知または連絡は、運営者の定める方法によって行うものとします。</p>
          <p>
            運営者は、利用者から運営者が別途指定する方法に従った変更届け出がない限り、現在登録されている連絡先が有効なものとみなして当該連絡先へ通知または連絡を行い、これらは、発信時に利用者へ到達したものとみなします。
          </p>

          <h2>第17条（権利義務の譲渡の禁止）</h2>
          <p>利用者は、運営者の書面による事前の承諾なくして、本規約に基づく権利および義務を第三者に譲渡または担保に供することはできません。</p>

          <h2>第18条（準拠法・裁判管轄）</h2>
          <p>
            本規約の解釈にあたっては、日本法を準拠法とします。本サービスに関して紛争が生じた場合、運営者の本店所在地を管轄する日本の裁判所を専属的合意管轄裁判所とします。
          </p>

          <h2>第19条（お問い合わせ窓口）</h2>
          <p>本規約に関するお問い合わせは、下記の窓口までお願いいたします。</p>
          <p>Eメールアドレス：{SUPPORT_EMAIL}</p>

          <p>制定日：2025年3月3日</p>
          <p>改定日：2026年1月14日</p>
        </section>
      </main>
      <footer className="SiteFooter">
        <small>© {new Date().getFullYear()} YStudioX</small>
      </footer>
    </div>
  );
}

export default HeadacheNoteTerms;


